import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import $ from "jquery";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import config from "./config";
import { BrowserRouter } from "react-router-dom";
import { applyThemeBtnColor } from "./themeManager";

// Apply saved theme button color on initial load
applyThemeBtnColor();

$.ajaxSetup({
  headers: {
    "Content-Type": "application/json",
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("inventory"))?.token,
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter basename={config.baseUrl}>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);
